var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tag-list" },
    _vm._l(_vm.tagList, function (tag, i) {
      return _c(
        "el-tag",
        {
          key: tag,
          attrs: { type: "info", "disable-transitions": "", closable: "" },
          on: {
            close: function ($event) {
              return _vm.updateTag(i)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(tag) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }